const Login = {
  setMsgResponse: function (_msg, _type, _$parent) {
    /*
      O tipo pode conter um dos 3 valores: success, warning, error ou CLEAR.
      O type CLEAR limpa as mensagens e faz sumir a mensagem
    */

    // Verifica se não há mais de uma mensagem
    // caso tenha, gera um html para cada mensagem
    if (Array.isArray(_msg)) {
      var msgArr = _msg;
      _msg = '';
      for (var i = msgArr.length - 1; i >= 0; i--) {
        _msg += '<span class="msg error">' + msgArr[i] + '</span>';
      }
    }

    _$parent
      .find('[data-msg-retorno]')
        .removeClass('success')
        .removeClass('warning')
        .removeClass('error');

    _$parent.find('[data-msg-retorno] [data-msg]').empty();

    if (_type != 'clear') {
      _$parent.find('[data-msg-retorno]').addClass(_type);
      _$parent.find('[data-msg-retorno] [data-msg]').html(_msg);
    }
  },
  validateLogin: function (_$form) {
    var validated = true;
    var errorsTxt = [];

    if (_$form.find('[name="email"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu email!');
    }

    if (_$form.find('[name="password"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe a senha!');
    }

    return {validated: validated, errors: errorsTxt};
  },
  validateRegister: function (_$form) {
    var validated = true;
    var errorsTxt = [];

    if (_$form.find('[name="email"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu email!');
    }

    if (_$form.find('[name="password"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe uma senha!');
    }

    if (_$form.find('[name="password"]').val() != '') {
      var pass = _$form.find('[name="password"]').val();
      var confirmationPass = _$form.find('[name="password_confirmation"]').val();

      if (pass != confirmationPass) {
        validated = false;
        errorsTxt.push('Senha e confirmação são diferentes!');
      }
    }

    return {validated: validated, errors: errorsTxt};
  },
  validateRecover: function (_$form) {
    var validated = true;
    var errorsTxt = [];

    if (_$form.find('[name="email"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu email!');
    }

    return {validated: validated, errors: errorsTxt};
  },
  logar: function (_$form) {
    if (!_$form.hasClass('sending')) {
      $.ajax({
        url: '/entrar',
        type: 'POST',
        dataType: "json",
        data: _$form.serialize(),
        beforeSend: function () {
          _$form.addClass('sending');
        }
      })
      .done(function(resp) {
        //console.log("success", resp);

        if (resp.error) {
          Login.setMsgResponse(resp.error, 'error', _$form);
        }

        if (resp.client) {
          window.location.href = resp.redirect_to;
        }
      })
      .fail(function(resp) {
        //console.error("error", error.responseText);
      })
      .always(function() {
        //console.log("complete");
        _$form.removeClass('sending');
      });
    }
  },
  recoverPassord: function (_$form) {
    if (!_$form.hasClass('sending')) {
      $.ajax({
        url: '/recuperar_senha',
        type: 'POST',
        dataType: "json",
        data: _$form.serialize(),
        beforeSend: function () {
          _$form.addClass('sending');
        }
      })
      .done(function(resp) {
        //console.log("success", resp);

        if (resp.error) {
          Login.setMsgResponse(resp.error, 'error', _$form);
        }

        if (resp.ok) {
          Login.setMsgResponse(resp.ok, 'success', _$form);
        }

        /*if (resp.client) {
          window.location.href = resp.redirect_to;
        }*/
      })
      .fail(function(resp) {
        //console.error("error", error.responseText);
      })
      .always(function() {
        //console.log("complete");
        _$form.removeClass('sending');
      });
    }
  },
  init: function () {
    $('[data-content-login]').each(function (index, el) {
      // Animação
      $(el).on('click', '[data-forget-password]', function (event) {
        event.preventDefault();
        $(el).find('.wrapper-form-login').animate({ height: 'toggle' }, 500);
        $(el).find('.wrapper-form-recover').animate({ height: 'toggle' }, 500);
      });

      $(el).on('click', '[data-forget-password-back]', function (event) {
        event.preventDefault();
        $(el).find('.wrapper-form-login').animate({ height: 'toggle' }, 500);
        $(el).find('.wrapper-form-recover').animate({ height: 'toggle' }, 500);
      });

      $(el).on('submit', '[data-form-login]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var respValidated = Login.validateLogin($form);

        if (respValidated.validated) {
          Login.logar($form);
        } else {
          Login.setMsgResponse(respValidated.errors, 'error', $(this));
        }
      });

      $(el).on('submit', '[data-form-register]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var respValidated = Login.validateRegister($form);

        if (respValidated.validated) {
          Login.logar($form);
        } else {
          Login.setMsgResponse(respValidated.errors, 'error', $(this));
        }
      });

      $(el).on('submit', '[data-form-recover]', function (event) {
        event.preventDefault();

        var $form = $(this);
        var respValidated = Login.validateRecover($form);

        if (respValidated.validated) {
          Login.recoverPassord($form);
        } else {
          Login.setMsgResponse(respValidated.errors, 'error', $(this));
        }
      });
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  Login.init();
});
